<template>
  <div class="section-heading">
    <div>
      <p class="eyebrow">{{ eyebrow }}</p>
      <h2>{{ title }}</h2>
    </div>
    <router-link v-if="link" class="text-link" :to="link">{{ linkText }} <span>↗</span></router-link>
  </div>
</template>

<script>
export default {
  name: 'SectionHeading',
  props: { eyebrow: String, title: String, link: String, linkText: { type: String, default: '' } }
}
</script>
